import api from "../api";
import { IAnalysisDriver } from "../UseCases/Files/VideoFile/Analysis";
import { IAnalysisHandler } from "../UseCases/Interfaces";

class AnalysisDriver implements IAnalysisDriver {
  public analysis = async (fileId: string, handlers?: IAnalysisHandler) => {
    await api.requestAnalysis(fileId);

    let isDone = false;
    let analysisError: any; // error

    const checkStatus = () => {
      if (isDone) {
        if (handlers?.onDone) {
          handlers.onDone(fileId);
        }
        return;
      }

      if (analysisError != null) {
        if (handlers?.onCanceled) {
          handlers.onCanceled();
        }
      }

      this.checkAnalysis(fileId)
        .then(({ done, progress, error }) => {
          if (done) {
            isDone = true;
          }

          if (error) {
            analysisError = error;
          }

          if (!done) {
            if (handlers?.onProgress) {
              handlers.onProgress();
            }
          }

          setTimeout(() => {
            checkStatus();
          }, 5000);
        })
        .catch((e) => {
          analysisError = e;
          setTimeout(() => {
            checkStatus();
          }, 5000);
        });
    };
    checkStatus();
  };

  public checkAnalysis = async (fileId: string) => {
    const { data } = await api.checkAnalysis(fileId);
    return {
      done: data.done,
      progress: data.progress,
      error: data.error,
    };
  };
}

export default AnalysisDriver;
